// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3NyyW","dragIcon":"SortableItem_dragIcon__1MC70","disabled":"SortableItem_disabled__1TU1k"};